/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeploymentResourceDto
 */
export interface DeploymentResourceDto {
    /**
     * The ID of the resource.
     * @type {string}
     * @memberof DeploymentResourceDto
     */
    id: string;
    /**
     * The name of the resource.
     * @type {string}
     * @memberof DeploymentResourceDto
     */
    name: string;
}

/**
 * Check if a given object implements the DeploymentResourceDto interface.
 */
export function instanceOfDeploymentResourceDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function DeploymentResourceDtoFromJSON(json: any): DeploymentResourceDto {
    return DeploymentResourceDtoFromJSONTyped(json, false);
}

export function DeploymentResourceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeploymentResourceDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function DeploymentResourceDtoToJSON(value?: DeploymentResourceDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

